import { createFileRoute } from "@tanstack/react-router";
import { DealAnalysisPage } from "../../../../../pages/deal-analysis-page/deal-analysis-page";

export const Route = createFileRoute("/_auth/_deal/deals/$dealId/analysis")({
  component: DealAnalysisPage,
});
